<script>
import { BModal } from 'bootstrap-vue';
import Bee from '@mailupinc/bee-plugin';
import fonts from '../../services/fonts';
import { Confirm } from '../../services/Confirm';

export default {
  components: {
    BModal,
  },

  props: {
    user: {
      type: Object,
      required: true,
    },

    privpage: {
      type: Object,
      required: true,
    },

    checkout: {
      type: [
        Boolean, String,
      ],
      required: true,
    },
  },

  created () {
    Bus.$on('fieldsRetrieved', (fields) => (this.fields = fields));

    Bus.$on('styleUpdated', () => this.handleModal());

    window.onbeforeunload = (e) => {
      if (this.hasUnsavedChanges) {
        e.returnValue = 'Seu conteúdo não está salvo. Deseja realmente sair do editor?';
      }
    };

    Bus.$on('pageUpdated', (page) => this.updatePage(page));

    this.page = this.privpage;

    if (! this.privpage.html) {
      this.resetForms();
    }

    this.$nextTick(() => {
      this.authorize();
    });
  },

  mounted () {
    this.clip = (new ClipboardJS('#copyJSON').on('success', () => {
      Alert.success(this.__('JSON copiado!'));
    }));
  },

  data () {
    return {
      hasUnsavedChanges: false,
      bee: null,
      clip: null,
      show: false,
      showCustom: false,
      showBuilder: false,
      currentForm: null,
      fields: [
        //
      ],
      forms: [
        //
      ],
      page: {
        //
      },
      defaultForm: {
          structure: {
            title: 'Título do Formulário',
            description: 'Descrição do Formulário',
            attributes: {},
            fields: {
              name: {
                type: 'text',
                options: [],
                label: 'Nome',
                canBeRemovedFromLayout: false,
                attributes: {
                  name: 'name',
                  required: true
                }
              },
              email: {
                type: 'email',
                options: [],
                label: 'E-mail',
                canBeRemovedFromLayout: false,
                attributes: {
                  name: 'email',
                  required: true
                }
              },
              submit: {
                type: 'submit',
                canBeRemovedFromLayout: false,
                attributes: {
                  value: 'Enviar',
                }
              },
            },
            layout: [],
          },
        },
      config: {
        uid: `bee-${this.user.account}`,
        container: 'bee',
        autosave: 30,
        language: 'pt-BR',
        onChange: () => {
          this.hasUnsavedChanges = true;
        },
        contentDialog: {
          manageForm: {
            label: 'Editar formulário',
            handler: async (resolve, reject, current) => {
              Bus.$on('saveBeeForm', (form) => {
                this.show = false;
                this.currentForm = null;
                this.showBuilder = false;

                if (! form) {
                  this.currentForm = null;

                  reject();

                  return;
                }

                resolve(form);
              });

              if (current.layout.length === 0) {
                this.show = true;

                return;
              }

              if (current.attributes.dir) {
                const hash = current.attributes.dir;

                const {
                  body,
                } = await this.$http.get(`/form/checkout/${hash}/json`);

                this.currentForm = body;

                this.show = true;

                return;
              }

              const siteKey = atob(current.fields.submit.attributes['data-sitekey']);

              const formId = JSON.parse(siteKey);

              const form = {
                name: current.title,
                description: current.description,
                id: parseInt(formId['bulldesk-form-id'], 10),
                button: current.fields.submit.attributes.value,
                action: current.fields.submit.attributes['data-action'],
                action_content: current.fields.submit.attributes['data-callback'],
                hide_labels: formId.hide_labels === 'true',
              };

              this.handleCreate(form);
            },
          },
        },
        advancedPermissions: {
          content: {
            form: {
              properties: {
                editField: {
                  show: false,
                },
              },
            },
          },
        },
        editorFonts: {
          showDefaultFonts: false,
          customFonts: fonts,
        },
        onSave: (json, html) => this.save(json, html),
        onSaveAsTemplate: (json) => this.openSaveAsTemplateModal(json),
      },

      template: {
        saving: false,
        title: '',
        json: {
          //
        },
      },
    };
  },

  methods: {
    authorize () {
      this.$http.post('/integration/bee', { type: 'page' })
        .then(({ data }) => {
          this.bee = new Bee(data);
          this.config.defaultForm = this.defaultForm;

          this.bee.start(this.config, this.page.content)
            .then(() => {
              this.showCustom = true;
            });
        });
    },

    resetForms () {
      this.page.content.page.rows = this.page.content.page.rows.map((row) => {
        if (! row.columns) {
          return row;
        }

        row.columns = row.columns.map((column) => {
          if (! column.modules) {
            return column;
          }

          column.modules = column.modules.map((modul) => {
            if (! modul.descriptor.form) {
              return modul;
            }

            const form = {
              ...this.defaultForm,
              attributes: [],
            };

            modul.descriptor.form = {...modul.descriptor.form, ...form}

            return modul;
          });

          return column;
        });

        return row;
      });
    },

    handleGetForm () {
      const names = this.page.content.page.rows.reduce((string, row) => {
        if (! row.columns) {
          return string;
        }

        return row.columns.reduce((columnString, column) => {
          if (! column.modules) {
            return columnString;
          }

          return column.modules.reduce((moduleString, columnModule) => {
            if (! columnModule.descriptor.form) {
              return moduleString;
            }

            moduleString.push(columnModule.descriptor.form.structure.layout.map((item) => item[0]));

            return moduleString;
          }, [])
            .concat(columnString);
        }, [])
          .concat(string);
      }, []);

      return names;
    },

    handleCreate (form) {
      this.show = false;

      this.currentForm = form;

      this.showBuilder = true;
    },

    handleModal (flag = false) {
      if (! flag) {
        this.$refs['custom-css'].$refs['modal-page-css-editor'].hide();

        return;
      }

      this.$refs['custom-css'].$refs['modal-page-css-editor'].show();

      setTimeout(() => {
        this.$refs['custom-css'].$refs['css-code-editor'].codemirror.refresh();
      }, 200);
    },

    async clone () {
      if (! await Confirm(this.__('Deseja clonar esta landing page? A landing page clonada irá abrir em uma nova janela.'))) {
        return;
      }

      this.$http.post(`/page/${this.page.id}/clone`)
        .then(({ data }) => window.open(`/page/${data.id}`))
        .catch((error) => console.warn(error));
    },

    openPageSetup () {
      Bus.$emit('openPageSetup');
    },

    updatePage (page) {
      this.page.slug = page.slug;
      this.page.title = page.title;
      this.page.domain = page.domain;
      this.page.published = page.published;
      this.page.public_url = page.public_url;
      this.page.meta_description = page.meta_description;
    },

    save (json, html) {
      const content = JSON.parse(json);

      this.$http.put(`/page/${this.page.id}`, { content, html })
        .then(() => {
          Alert.success(this.__('Conteúdo salvo!'));
          
          this.hasUnsavedChanges = false;
        })
        .catch(({ data }) => {
          Alert.error(data.error);
        });
    },

    openSaveAsTemplateModal (json) {
      this.template.json = JSON.parse(json);

      this.$refs['save-template-modal'].show();
    },

    saveAsTemplate () {
      this.template.saving = true;

      this.$http.post('/page/template', {
        json: this.template.json,
        title: this.template.title,
      })
        .then(() => {
          Alert.success(this.__('Página salva como template.'));

          this.template.title = '';

          this.$refs['save-template-modal'].hide();
        })
        .catch(() => {
          Alert.error(this.__('Ops, não foi possível criar o template.'));
        })
        .finally(() => {
          this.template.saving = false;
        });
    },
  },

  computed: {
    pageDomainClass () {
      if (!this.page.published) {
        return 'page-not-published';
      }

      return 'page-published';
    },

    pageDomainColor () {
      if (!this.page.published) {
        return '#D1D1D1';
      }

      return this.page.isDomainCertified ? '#12BA7F' : '#CC0025';
    },
  },
};
</script>

<template>
  <section
    class="bd-page-builder"
  >
    <div
      class="row"
    >
      <div
        class="col-12 pl-30px d-flex align-items-center"
      >
        <h2
          class="page-subtitle"
        >
          {{ page.title || __('LP sem título') }}
        </h2>

        <div :class="pageDomainClass" class="ml-auto pt-5px builder-domain-label">
          <IconClosedLock
            class="lock-icon"
            :size="16"
            v-if="page.isDomainCertified"
            :color="pageDomainColor"
          />
          <IconOpenLock
            class="lock-icon"
            :size="16"
            v-else
            :color="pageDomainColor"
          />
          <span class="ml-1">
            {{ page.isDomainCertified ? __('Ativo') : __('Inativo') }}
          </span>
        </div>

        <a
          href="#"
          @click.prevent="handleModal"
          class="builder-link ml-4 pt-5px"
        >
          <IconFrame
            :size="15"
            color="#71767D"
            class="page-builder__custom-button-icon"
          />

          <span
            class="builder-label ml-2"
          >
            {{ __('Editor de CSS') }}
          </span>

        </a>

        <a
          target="_blank"
          :href="page.public_url"
          class="builder-link ml-4 pt-5px"
        >
          <IconEye color="#71767D" />

          <span
            class="builder-label ml-2"
          >
            {{ __('Visualizar') }}
          </span>
        </a>

        <a
          href="#"
          @click.prevent="clone"
          class="builder-link ml-4 pt-5px"
        >
          <IconCopy
            :size="18"
            color="#71767D"
          />

          <span
            class="builder-label ml-2"
          >
            {{ __('Clonar') }}
          </span>
        </a>

        <a
          href="#"
          id="copyJSON"
          v-if="user.root"
          class="builder-link ml-4 pt-5px"
          :data-clipboard-text="JSON.stringify(page.content)"
        >
          <IconCopy
            id="copy"
            :size="18"
            color="#71767D"
          />

          <span
            class="builder-label ml-2"
          >
            {{ __('Copiar JSON') }}
          </span>
        </a>

        <a
          href="#"
          @click.prevent="openPageSetup"
          class="builder-link ml-4 pt-5px"
        >
          <IconCog
            color="#71767D"
            :size="19"
          />

          <span
            class="builder-label ml-2"
          >
            {{ __('Configurações') }}
          </span>
        </a>

        <PageSetup
          class="ml-4"
          :page="page"
          color="#71767D"
          />

        <span
          class="builder-label ml-2 pt-6px"
        >
          {{ __('Publicar') }}
        </span>
      </div>
    </div>

    <div
      id="bee"
      :class="{ 'is-disabled': show || showBuilder }"
    />

    <div
      v-if="show"
      class="page-builder__form"
    >
      <FormBuilderDialog
        :user="user"
        :page="page.id"
        @close="show = false"
        @create="handleCreate"
        :form.sync="currentForm"
        :has-checkout="checkout"
        class="page-builder__form-modal"
      />
    </div>

    <div
      v-if="showBuilder"
      class="page-builder__form"
    >
      <FormBuilder
        :page="page.id"
        :form="currentForm"
        :data-fields="fields"
        @close="show = false"
        hide-integration="hideIntegration"
        class="page-builder__form-form"
      />
    </div>

    <PageCssEditor
      ref="custom-css"
      style="display: none"
      :css="page.custom_css"
      :url="'/page/' + page.id"
    />

    <BModal
      id="save-template-modal"
      ref="save-template-modal"
      hide-footer="hide-footer"
      modal-class="modal-width-340"
    >
      <template
        slot="modal-title"
      >
        Salvar como template
      </template>

      <template
        slot="default"
      >
        <form
          class="form"
          method="post"
        >
          <div
            class="form-group"
          >
            <label>
              Título
            </label>

            <input
              type="text"
              required=""
              class="form-control"
              v-model="template.title"
            >
          </div>

          <div
            class="modal-footer default-modal-footer"
          >
            <button
              type="submit"
              class="btn btn-box"
              :disabled="template.saving"
              @click.prevent="saveAsTemplate"
            >
              <span
                v-if="! template.saving"
              >
                Salvar
              </span>

              <span
                v-else
              >
                <i
                  class="fa fa-circle-o-notch fa-spin mr-1"
                />

                Salvando...
              </span>
            </button>
          </div>
        </form>
      </template>
    </BModal>
  </section>
</template>

<style lang="scss" scoped>
  @import '../../../sass/variables';
  @import '../../../sass/mixins';

  .builder-domain-label {
    @include salesflow-text($font-weight: 600, $color: $salesflow-font-gray);
  }

  .page-not-published {
    color: $salesflow-outline-gray-medium;
  }

  .lock-icon {
    position: relative;
    top: -2px;
  }

  .bd-page-builder {

    .builder-link {
      color: $white;
      white-space: nowrap;

      &:hover {
        text-decoration: none;
      }
    }

    .builder-label {
      @include salesflow-text($color: $salesflow-font-gray, $font-weight: 600);

      &:hover {
        text-decoration: underline;
      }
    }

    .page-builder__form {
      bottom: 0;
      z-index: 2;
      left: 20px;
      right: 20px;
      display: flex;
      position: absolute;
      align-items: center;
      padding-top: 1.5rem;
      margin-bottom: 3rem;
      justify-content: center;
      height: calc(100% - 200px);
      box-shadow: 0 5px 20px rgba(165, 131, 224, 0.15);

      &-form {
        width: 100% !important;
        height: 100% !important;
      }
    }

    #bee {
      height: 100vh;
      position: relative;
      padding-top: 1.5rem;
      margin-bottom: 3rem;
      box-shadow: 0 5px 20px rgba(165, 131, 224, 0.15);

      &.is-disabled {
        display: none;
        pointer-events: none;
      }

      .page-builder__custom {
        left: 326px;
        height: 28px;
        display: flex;
        min-width: 156px;
        padding: 6px 10px;
        position: absolute;
        align-items: center;
        box-sizing: border-box;
        justify-content: center;
        top: calc(1.5rem + 13px);
        border-left: 1px solid #6d6d6d;

        &-button {
          border: none;
          display: flex;
          color: $white;
          font-size: 12px;
          font-weight: 500;
          align-items: center;
          justify-content: center;
          background: transparent;
          font-family: $font-family-sans-serif;

          &-icon {
            margin-right: 6px
          }
        }
      }
    }

    @media (max-width: 1200px) {
      .page-subtitle {
        width: 30%;
        margin-right: 6px;
      }
    }
  }
</style>
